import firebase from 'firebase/app';
import 'firebase/firebase-firestore';
import 'firebase/firebase-auth';
import 'firebase/firebase-storage';
import 'firebase/firebase-analytics';
import 'firebase/firebase-functions';

var firebaseConfig = {
    apiKey: "AIzaSyA0X6pDNwodoeMyyrZwpFUb1rfUMjP_ss8",
    authDomain: "wash-my-car-online.firebaseapp.com",
    databaseURL: "https://wash-my-car-online.firebaseio.com",
    projectId: "wash-my-car-online",
    storageBucket: "wash-my-car-online.appspot.com",
    messagingSenderId: "706796151280",
    appId: "1:706796151280:web:3b8c8e0b0e87e7a5c83d35",
    measurementId: "G-6E1N1GLW26"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export var db = firebase.firestore();
export var storage = firebase.storage();
export var auth = firebase.auth();
export var serverTimestamp = firebase.firestore.FieldValue.serverTimestamp;
export var functions = firebase.app().functions('asia-east2');
export var fieldValue = firebase.firestore.FieldValue;
export var geoPoint = firebase.firestore.GeoPoint;


let isLocalHost = window.location.hostname === "localhost";

if (isLocalHost) {
  console.log("localhost detected!");
  db.settings({
    host: "localhost:8000",
    ssl: false
  });

  functions.useFunctionsEmulator("http://localhost:5001");
}